import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { format } from 'date-fns';
import { Card } from '@/components/ui/card';
import { GridEditor } from '@/features/Grids/GridEditor';
import { MonitorAlertEventDto } from '@/app/Alert/types';

interface AdminEventProps {
  event: MonitorAlertEventDto;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function AdminEvent({ event, open, onOpenChange }: AdminEventProps) {
  const formatDate = (date?: string | Date) => {
    if (!date) return '';
    return format(new Date(date), 'PPp');
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="w-full max-w-4xl">
        <DialogHeader>
          <DialogTitle>Event Details</DialogTitle>
        </DialogHeader>

        <div className="space-y-6 p-4">
          <Card className="p-4">
            <div className="grid grid-cols-3 gap-4">
              <div className="space-y-1">
                <label className="text-sm font-medium">Time</label>
                <p className="text-sm">{formatDate(event.occurred)}</p>
              </div>
              <div className="space-y-1">
                <label className="text-sm font-medium">Type</label>
                <p className="text-sm">{event.type}</p>
              </div>
              <div className="space-y-1">
                <label className="text-sm font-medium">Camera</label>
                <p className="text-sm">{event.nvrDeviceName}</p>
              </div>
            </div>
          </Card>

          {event.values && event.values.length > 0 && (
            <div className="space-y-2">
              <h3 className="text-lg font-semibold">Edit Grid</h3>
              {event && (
                <GridEditor
                  event={event}
                  onSave={() => onOpenChange(false)}
                />
              )}
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
